import { render, staticRenderFns } from "./appletcolumn.vue?vue&type=template&id=23239bda&scoped=true&"
import script from "./appletcolumn.vue?vue&type=script&lang=js&"
export * from "./appletcolumn.vue?vue&type=script&lang=js&"
import style0 from "./appletcolumn.vue?vue&type=style&index=0&id=23239bda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23239bda",
  null
  
)

export default component.exports